import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getAppBaseUrl } from './getAppBaseUrl'

export const getAppVersion = async (
  editorSdkProxy: EditorSDK,
): Promise<string> => {
  const appBaseUrl = await getAppBaseUrl(editorSdkProxy)
  const segments = appBaseUrl.split('/')
  const version = segments[segments.length - 1]
  if (!/^[\d.A-Za-z]+$/.test(version)) {
    return ''
  }
  return version
}
